<button
  type="button"
  aria-label="Voltar"
  class="glass-panel active-press fixed bottom-8 left-8 z-50 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full text-on-surface transition-transform duration-200 hover:scale-110 hover:text-primary"
>
  <span class="material-symbols-outlined">arrow_back</span>
</button>
